import React from 'react'
import ReactDOM from 'react-dom'
import { renderNotification } from '../utils/flash_notifications';
import Modal from '../components/Modal';
import AiPlaceSuggestionsContainer from '../components/AiPlaceSuggestionsContainer';

const AiPlaceSuggestionsGenerator = () => {
  const elements = document.querySelectorAll('.js-generate-place-suggestions-with-ai')
  const countryElement = document.getElementById('country');
  
  if(!countryElement) return

  const countryId = countryElement.getAttribute('data-country-id');

  function renderModal(data) {
    ReactDOM.render(
      <Modal isOpen={true}>
        <AiPlaceSuggestionsContainer data={data} countryId={countryId} />
      </Modal>,
      document.querySelector('.js-modal')
    )
  }
  function handleClick(e) {
    e.preventDefault()
    renderNotification('Generating suggestions...', 'success')
    
    fetch('/generate_place_suggestions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ country_id: countryId })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data.suggestions);
      renderModal(data.suggestions)

      renderNotification("Suggestions generated!", 'success')
    })
    .catch(error => console.error('Error:', error));
  }

  elements.forEach(element => {
    ReactDOM.render(
      <a onClick={(e) => handleClick(e)} className="button--success"> Generate place suggestions</a>,
      element
    )
  })
}

export default AiPlaceSuggestionsGenerator;
